jQuery(($) => {

    function openInput($element) {
        $element.closest(".gfield").addClass("gfield--focused");
    }

    function maybeCloseInput($element) {
        if ($element.val() !== '') {
            $element.closest(".gfield").addClass("gfield--focused").removeAttr("style");
        } else {
            $element.closest(".gfield").removeClass("gfield--focused");
        }
    }

    if ($('.gfield input[type="text"]')[0]) {
        $(document).on('gform_post_render', function () {
            var $inputs    = $(".gfield input[type='text']"),
                $textareas = $(".gfield textarea"),
                $selects   = $(".gfield select");

            // If input or textarea has value, open it
            $inputs.each(function () {
                if ($(this).val() !== '') {
                    openInput($(this));
                }
            });

            $textareas.each(function () {
                if ($(this).val() !== '') {
                    openInput($(this));
                }
            });

            // If input, textarea, or select focused, open it
            $inputs.focus(function () {
                openInput($(this));
            });

            $textareas.focus(function () {
                openInput($(this));
            });

            $selects.focus(function () {
                openInput($(this));
            });

            // If input, textarea, or select blurred, close if has no value
            $inputs.blur(function () {
                maybeCloseInput($(this));
            });

            $textareas.blur(function () {
                maybeCloseInput($(this));
            });

            $selects.blur(function () {
                maybeCloseInput($(this));
            });

        }).trigger('gform_post_render');
    }

    $(".gfield").mouseenter(function () {
        $(this).addClass('gfield--hovered');
    }).mouseout(function () {
        $(this).removeClass('gfield--hovered');
    });

    $(document).on('gform_post_render', function () {
        $('.m-gravity-form form .gform_page_footer .button').click(function(){
            var footer = $(this).parent(),
                form   = footer.closest('form');

            if (!(form.hasClass('loading'))) {
                form.addClass('loading');
            };
        });

        $('.m-gravity-form form .gform_page_footer .a-button').click(function(){
            var footer = $(this).parent(),
                form   = footer.closest('form');

            if (!(form.hasClass('loading'))) {
                form.addClass('loading');
            };
        });
    }).trigger('gform_post_render');

});